import React, { createContext, useCallback, useContext, useState } from "react";

const DrawerContext = createContext(null);

export const DrawerProvider = ({ children }) => {
    const [open, setOpen] = useState(false);
    const openDrawer = useCallback(() => setOpen(true), []);
    const closeDrawer = useCallback(() => setOpen(false), []);
    return (
        <DrawerContext.Provider value={{ open, openDrawer, closeDrawer }}>
            {children}
        </DrawerContext.Provider>
    );
};

export const useDrawer = () => {
    const ctx = useContext(DrawerContext);
    if (!ctx) throw new Error("useDrawer must be used inside DrawerProvider");
    return ctx;
};
